var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 14.3333H26.28C28.0722 14.3333 28.9683 14.3333 29.6528 14.6966C30.2549 15.0162 30.7444 15.5262 31.0512 16.1534C31.4 16.8664 31.4 17.7998 31.4 19.6667V31M18.6 31V6.33333C18.6 4.46649 18.6 3.53307 18.2512 2.82003C17.9444 2.19282 17.4549 1.68289 16.8528 1.36331C16.1683 1 15.2722 1 13.48 1H7.72C5.92783 1 5.03175 1 4.34723 1.36331C3.74511 1.68289 3.25557 2.19282 2.94878 2.82003C2.6 3.53307 2.6 4.46649 2.6 6.33333V31M33 31H1M8.2 7.66667H13M8.2 14.3333H13M8.2 21H13",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.09ca802f8595032a1ced01717d4ae6e1.svg";
export { ForwardRef as ReactComponent };